const REJECTION_REASONS = [
  { value: 'offer_too_high', label: 'Za wysoka wartość oferty' },
  { value: 'delivery_date', label: 'Termin dostawy' },
  { value: 'no_stock', label: 'Brak towaru' },
  { value: 'other', label: 'Inne' },
];

export const formatCurrency = (amount) => {
  return parseFloat(amount || 0).toLocaleString('pl-PL', { style: 'currency', currency: 'PLN' });
};

export const getRejectionLabel = (reason) => {
  const r = REJECTION_REASONS.find(rr => rr.value === reason);
  return r ? r.label : reason;
};
